import React from "react";
import { aboutPillars } from "../../aboutData";

export default function FourPillars() {
  return (
    <section className="mu-section-lilac">
      <div className="container">
        <div className="mb-4">
          <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>What We Do</div>
          <h2 className="section-title">Four Pillars, One Platform</h2>
        </div>

        <div className="row g-4">
          {aboutPillars.map((p, i) => (
            <div className="col-6 col-lg-3" key={i}>
              <div className="feature-card">
                <div className="feature-icon"></div>
                <h6>{p.title}</h6>
                <p>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
